module.exports = __webpack_public_path__ + "img/25200.c76e9227.jpg";